/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetLocalCashDetailRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {GetLocalCashDetailResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const getLocalCashDetail = (request: GetLocalCashDetailRequest, options?: CashRequestOptions) => post<GetLocalCashDetailRequest, GetLocalCashDetailResponse>("/2.0/cash/get-local-cash-detail", request, {...options, rejectOnError: true })